import { CounterLoadingTypes } from 'front-commons/ds/components/Counter/interfaces';
import { CustomError } from 'shared/errors';
import { simulatedViewType } from 'stores/customer/helpers';
import { AddBasketItemsParams } from './interfaces';
import { FindBasketProductsResponse } from 'services/basket/interfaces';

export const manageAmountByMethod: Record<
	string,
	(props: { value?: AddBasketItemsParams['amount']; maxQuantity?: number | null }) => number
> = {
	add() {
		return 1;
	},
	increment({ value }) {
		return Number(value) + 1;
	},
	decrement({ value, maxQuantity }) {
		const prevValueNumber = Number(value);

		if (maxQuantity && prevValueNumber > maxQuantity) return maxQuantity;

		return prevValueNumber < 1 ? 0 : prevValueNumber - 1;
	},
};

export const getManageProductMessage = (method: CounterLoadingTypes) => {
	switch (method) {
		case 'decrement':
			return 'Unidade do produto removida';
		case 'increment':
			return 'Unidade do produto adicionada';
		case 'typing':
			return 'Quantidade do produto atualizada';
		default:
			return 'Produto adicionado ao carrinho';
	}
};

export const getNotificationMessage = (error: unknown) => {
	if (error === 'forbidden' && !!simulatedViewType()) {
		return 'Esse é um usuário simulado. Você não pode realizar essa ação.';
	}

	return error instanceof CustomError
		? error.message
		: 'Não foi possível atualizar a quantidade desse item, tente novamente.';
};

export function getFreshBasketData(data: FindBasketProductsResponse, productId?: string) {
	const allProducts = data.baskets?.flatMap((basket) => basket.products) ?? [];
	const freshProduct = allProducts.find((product) => product.id === productId);

	return {
		cartValue: data.finalTotalPrice,
		productValue: freshProduct?.totalPricePromotion,
		totalLiquid: data.totalPrice - data.discount,
		itemsCount: allProducts.length,
	};
}

export type BasketChangeSource = 'increase_quantity' | 'add_item' | 'remove_item';

interface BasketChangeInfo {
	type: 'add_to_cart' | 'remove_from_cart';
	updateQuantity: number;
	changeSource: BasketChangeSource;
}

export function getBasketChangeInfo(lastAmount: number, currentAmount: number): BasketChangeInfo | undefined {
	if (currentAmount > lastAmount) {
		const changeSource: BasketChangeSource = lastAmount === 0 ? 'add_item' : 'increase_quantity';

		return {
			type: 'add_to_cart',
			updateQuantity: currentAmount - lastAmount,
			changeSource,
		};
	}

	if (currentAmount < lastAmount) {
		return {
			type: 'remove_from_cart',
			updateQuantity: lastAmount - currentAmount,
			changeSource: 'remove_item',
		};
	}

	return undefined;
}
